/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagealt1Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_imagealt1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft budget workbook with amounts, conditional formatting and a comparison chart`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_imagealt1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 预算工作簿，包含金额、条件格式和对比图表`)
};

/**
* | output |
* | --- |
* | "GridCraft budget workbook with amounts, conditional formatting and a comparison chart" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagealt1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_imagealt1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagealt1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Imagealt1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_imagealt1(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_imagealt1(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_imagealt1 as "gc.search_guides.gridcraft_excel_compatibility.imageAlt" }